import { CHARACTER_TYPE, PIECES_HUMAN_TYPE } from '../types/enums';

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const isPC = () => {
  return !isMobile();
};

export const isTablet = () => {
  return /Tablet|iPad|iPod/i.test(navigator.userAgent);
};

export const isDesktop = () => {
  return !isMobile() && !isTablet();
};

/**
 * 判断是否2d数字人作品
 * @export
 */
export const is2DCharacterPieces = (type: PIECES_HUMAN_TYPE | string[]) => {
  return type === PIECES_HUMAN_TYPE.HUMAN_2D;
};

export const is2DCharacter = (type: string[] | undefined) => {
  if (!type || type.length === 0) {
    return false;
  }
  return type.includes(CHARACTER_TYPE.CHARACTER_2D);
};
